<template>
  <div class="fill-height">


    <v-card class="fill-height">
      <v-card-title  class="p-1">
        <v-chip
            label    small
            class="ma-2"
            color="secondary">
        گزارش پرداختی ها
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="$router.push('/home')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>


      <v-card-text>
        <v-spacer/>
        <v-row>
          <v-col
              cols="12"
              md="3">

            <v-autocomplete
                :items="data.buildingList"
                v-model="params.buildingIds"
                dense
                multiple
                outlined
                :error-messages="getError('buildingIds')"
                auto-select-first  append-icon="fas fa-angle-down"
                label="انتخاب مجتمع"

            />

          </v-col>

          <v-col
              cols="12"

              md="3">

            <v-autocomplete
                :items="data.paymentStatusItem"
                v-model="params.status"
                dense
                outlined
                :error-messages="getError('status')"
                auto-select-first  append-icon="fas fa-angle-down"
                label="وضعیت پرداخت"

            />

          </v-col>

          <v-col
              cols="12"

              md="3">
            <date-picker placeholder="از تاریخ" v-model="params.dateFrom" color="#3b5694" clearable
                         auto-submit>
            </date-picker>
            <span style="color: red" v-if="getError('dateFrom')" v-text="getError('dateFrom')"/>
          </v-col>

           <v-col
              cols="12"
              md="3" class="d-inline-flex ">
            <date-picker placeholder="تا تاریخ" v-model="params.dateTo" color="#3b5694" clearable
                         auto-submit>
            </date-picker>
            <span style="color: red" v-if="getError('dateTo')" v-text="getError('dateTo')"/>
             <v-btn small fab color="primary" class="mr-1" @click="search"><v-icon>mdi-cloud-search</v-icon></v-btn>
          </v-col>

        </v-row>


        <v-spacer/>
      </v-card-text>
      <v-card-text>
        <b-table

            :items="dataItems"
            :fields="columns"
            stacked="md"
            show-empty
            responsive
            striped>

        </b-table>

      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import Reporting from "@/views/reporting/Reporting";
import {mapMutations} from "vuex";

export default {

  name: 'Manager',

  data() {
    return {
      buildingIds:[],
      data: {},
      params: {},
      dataItems: [],
      bindingErrors: [],

      columns: [
        {key: 'establishment.user.person.fullName', label: 'نام شخص', },
        {key: 'establishment.unit.building.name', label: 'نام مجتمع ', },
        {key: 'establishment.unit.unitName', label: 'نام واحد', },
        {key: 'amount', label: 'مبلغ(ریال)',  formatter: (value) => value.toLocaleString()},
        {key: 'typeChargeText', label: 'نوع شارژ', },
        {key: 'bankPort', label: 'درگاه پرداختی', },
        {key: 'paymentDateText', label: 'تاریخ پرداخت', width:200},
        {key: 'description', label: 'توضیحات', },

      ],

    };

  },

  methods: {
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),
    handleInput (value) {
      this.$emit('input', value)
    },

    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find( ({ fieldName }) => fieldName === key );
        if(error && error.message ) return  error.message[0]
      }
      return ''
    },

    fillDataItems() {
      Reporting.getPage().then(response => {
        this.data = response.data
        this.params = response.data.params
      });
    },

    search() {
      this.dataItems=[]
      this.bindingErrors=[]
      this.$progress({message: 'درحال جستجو...'}, true)
       Reporting.search(this.params).then(response => {
        if (response && response.status === 200) {
          this.$root.$emit('Progress')
          this.dataItems = response.data
        }else if (response && response.response.status === 400) {
          this.$root.$emit('Progress')
          this.bindingErrors = response.response.data;
        }
      })
    },

  },



created() {
    this.fillDataItems()
  this.setDrawer(false)
}

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
